import { useForm } from "@mantine/form";
import {
  TextInput,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Divider,
  Anchor,
  Stack,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { setData, setGroup, setToken, setUserId } from "../misc/tokens";
import { handleLogin } from "../misc/api";
import { ENV_CONFIG } from "../misc/config";

export function LoginScreen() {
  const [error, setError] = useState(null);
  //const [isLoggedIn, setLoggedin] = useState(getToken());

  let navigate = useNavigate();
  const form = useForm({
    initialValues: {
      email: "",
      name: "",
      password: "",
      terms: true,
    },

    validate: {
      email: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  const handleSubmit = async (e) => {
    //e.preventDefault();
    if (form.values.email && form.values.password) {
      setError(null);
      try {
        const response = await handleLogin(
          form.values.email,
          form.values.password
        );
        if (!response.ok) {
          setError("Invalid email or password!");
          throw new Error("Incorrect email or password");
        }
        const { data } = await response.json();
        const { token, data: userData } = data;

        setToken(token);
        setGroup(userData.group);
        setUserId(userData.uid);
        setData(userData);
        // navigate("/main");
        window.location.href = "/main";
      } catch (err) {
        setError(err.message);
      }
    } else {
      setError("Invalid email or password!");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "darkslategray",
        paddingTop: "10%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: 80,
        minHeight: "100vh",
      }}
    >
      <Paper
        radius="md"
        p="xl"
        withBorder
        style={{ width: 500, marginLeft: "auto", marginRight: "auto" }}
      >
        <Text size="lg" weight={500}>
          Welcome to Spilve
        </Text>
        <Divider label="Login with email" labelPosition="center" my="lg" />
        <form
          onSubmit={form.onSubmit((e) => {
            handleSubmit(e);
            //window.location.href = "/account";
          })}
        >
          <Stack>
            <TextInput
              required
              label="Email"
              placeholder="hello@spilve.com"
              value={form.values.email}
              onChange={(event) =>
                form.setFieldValue("email", event.currentTarget.value)
              }
              error={form.errors.email && "Invalid email"}
              radius="md"
            />
            <PasswordInput
              required
              label="Password"
              placeholder="Your password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={
                form.errors.password &&
                "Password should include at least 6 characters"
              }
              radius="md"
            />
          </Stack>
          {error && <span style={{ color: "red" }}>{error}!</span>}
          <Group position="apart" mt="xl">
            <Button type="submit" radius="xl">
              Login
            </Button>

            <Anchor
              component="button"
              type="button"
              color="dimmed"
              onClick={() => navigate("/register-single")}
              size="xs"
            >
              Or register a flight
            </Anchor>
          </Group>
          {ENV_CONFIG.ENABLE_REGISTRATION && <Anchor
            component="button"
            type="button"
            color="dimmed"
            onClick={() => navigate("/register-account")}
            size="xs"
            style={{marginTop: 30}}
          >
            Don't have an account? Register
          </Anchor>}
        </form>
      </Paper>

      {/* LIAA Project Poster */}
      <img
        src="/LIAA_plakats.png"
        alt="LIAA projekta informācija"
        style={{
          marginTop: 40,
          maxWidth: 500,
          width: '90%',
          borderRadius: 8,
        }}
      />
    </div>
  );
}
